import { IFormatNumberHelper } from '../services';

export const filterId = 'wtNumber';

export const factory = ['formatNumberHelper', (helper: IFormatNumberHelper) => {
    const myFunction = (input: any, decimals: any) => {
        return helper.format(input, decimals);
    };

    return myFunction;
}];